module.exports = __webpack_public_path__ + "static/media/servicios_protecciondatospersonales.94611019.jpg";